export const LabelText = {
  TITLE: 'Order summary',
  TOTAL: 'Total (Incl. GST)',
  SUBTOTAL: 'Subtotal',
  DISCOUNT: 'discount'
};
